import mod from "-!./MessageUI.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./MessageUI.js?vue&type=script&lang=js&external"